import React from 'react'
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import Redirect from "../../helpers/Redirect";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import Colors from "../../config/colors";
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CardHeader from "@material-ui/core/CardHeader";
import AppButton from "../../ui/AppButton";
import Session from "../../helpers/Session";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import AppInputPasswordView from "../../ui/AppInputPasswordView";
import {withRouter} from 'react-router';
import Alert from "@material-ui/lab/Alert";
import {validarContrasenaSegura} from "../../helpers/Helpers";

class ChangePassword extends React.Component {

    state = {
        form: {
            terceroPassword: '',
            terceroPasswordNuevo: '',
            terceroPasswordNuevoConfirm: '',
        },
        url: ''
    };

    validate = () => {

        if (!validarContrasenaSegura(this.state.form.terceroPasswordNuevo)) {
            AppToast('¡La nueva contraseña no es válida!', false);
            return false;
        }

        // Valida que las contraseñas coincidan
        if (!this.validateConfirmPassword(this.state.form.terceroPasswordNuevo, this.state.form.terceroPasswordNuevoConfirm)) {
            return false;
        }
        return true;
    }

    validateConfirmPassword = (password, confirmPassword) => {
        if (password !== confirmPassword) {
            AppToast('Las contraseñas no coinciden!', false);
            return false;
        }
        return true;
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        // Realiza las validaciones del formulario
        if (!this.validate()) {
            return;
        }

        const userData = Session.getLogin();
        let params = {
            ...this.state.form,
            terceroID: userData.terceroID
        }
        const data = await Api.post(`${Env.UrlSeguridad}/postTerceroPassUdp`, params);
        if (data.cod === '1') {
            AppToast('La contraseña se cambió con éxito.', true);
            this.setState({
                url: '/accounts'
            });
        } else {
            AppToast(data.msg, false);
        }
    }

    handleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    }

    render() {
        return (
            <div className='container-form'>
                <Redirect url={this.state.url}/>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        }
                    ]}
                    actual='Cambiar contraseña'
                />

                <div>
                    <form onSubmit={this.handleSubmit}>
                        <Grid
                            container
                            direction="column"
                            justify="flex-start"
                            alignItems="center">

                            <Card className='container-login'>

                                <Avatar style={{background: Colors.accent, marginLeft: '45%'}}>
                                    <LockOpenIcon />
                                </Avatar>

                                <CardHeader title="Cambiar contraseña"/>

                                <Grid container spacing={2}>
                                    <Grid item xs={12}>

                                        <AppInputPasswordView
                                            id='terceroPassword'
                                            name='terceroPassword'
                                            value={this.state.form.terceroPassword}
                                            label='Contraseña actual'
                                            onChange={this.handleChange}
                                            required={true}
                                            labelWidth={150}
                                        />

                                    </Grid>
                                    <Grid item xs={12}>

                                        <AppInputPasswordView
                                            id='terceroPasswordNuevo'
                                            name='terceroPasswordNuevo'
                                            value={this.state.form.terceroPasswordNuevo}
                                            label='Nueva contraseña'
                                            onChange={this.handleChange}
                                            required={true}
                                            labelWidth={150}
                                        />

                                    </Grid>
                                    <Grid item xs={12}>

                                        <AppInputPasswordView
                                            id='terceroPasswordNuevoConfirm'
                                            name='terceroPasswordNuevoConfirm'
                                            value={this.state.form.terceroPasswordNuevoConfirm}
                                            label='Repita la nueva contraseña'
                                            onChange={this.handleChange}
                                            required={true}
                                            labelWidth={210}
                                        />

                                    </Grid>

                                    <Grid item xs={12}>
                                        <Alert severity="info">
                                            La contraseña debe ser de ocho caracteres mínimo, contener una letra en mayúscula y un número.
                                        </Alert>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <AppButton
                                            type='submit'
                                            label='Guardar'
                                            size='large'
                                        />
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </form>
                </div>
            </div>
        );
    }

}

export default withRouter(ChangePassword)